import React from "react";
import PropTypes from "prop-types";
import useComponentDidMount from "@hooks/UseComponentDidMount";

const Video = React.memo(({ id, onObjectLoad }) => {
  useComponentDidMount(() => {
    onObjectLoad(id);
  });
  return null;
});

Video.propTypes = {
  id: PropTypes.string.isRequired,
  onObjectLoad: PropTypes.func.isRequired,
};

export default Video;
